
import { ElForm } from 'element-ui/types/form'
import { Component, Vue, Ref } from 'vue-property-decorator'
import { MediaService } from '@/services'

@Component({
    name: 'MediaNews'
})
export default class extends Vue {
    @Ref('formRef') private formEl!: ElForm
    private submitLoading = false
    private form = {
        medium_id: '',
        title: '',
        content: '',
        origin_url: '',
        cover_img: '',
        published_at: '',
        read_count: '0',
        like_count: '0',
        comment_count: '0',
        share_count: '0',
        is_free: true,
        reporter_names: '',
        special_reporter_names: '',
        correspondent_names: '',
        author_names: '',
        intern_reporter_names: ''
    }
    private rules = (() => {
        const publicRules = {
            required: true,
            message: '该项为必填项'
        }
        const excludes = [
            'cover_img',
            'is_free',
            'reporter_names',
            'special_reporter_names',
            'correspondent_names',
            'author_names',
            'intern_reporter_names'
        ]
        return Object.keys(this.form)
            .filter(key => !excludes.includes(key))
            .reduce((prev: any, curKey: string) => Object.assign(prev, { [curKey]: publicRules }), {})
    })()

    onCreateNews() {
        this.formEl.validate(async (isValid: boolean) => {
            if (!isValid) return
            this.submitLoading = true
            const splitStr = (str: string) => str.split(/[\n,]/g).filter(Boolean)
            const params = {
                ...this.form,
                is_free: Number(this.form.is_free),
                reporter_names: splitStr(this.form.reporter_names),
                special_reporter_names: splitStr(this.form.special_reporter_names),
                correspondent_names: splitStr(this.form.correspondent_names),
                author_names: splitStr(this.form.author_names),
                intern_reporter_names: splitStr(this.form.intern_reporter_names)
            }
            const result = await MediaService.createMediaNews(params)
            this.submitLoading = false
            if (result.status === 200) {
                this.formEl.resetFields()
                return this.$msuccess('提交成功')
            }
            this.$merror(result.message || '发生错误, 请稍后再试')
        })
    }
}
